import { Injectable, Injector, ViewContainerRef, ComponentRef, inject } from '@angular/core';
import { SkeletonLoaderTemplatesComponent } from '../skeleton-loader-templates/skeleton-loader-templates.component';

@Injectable({
  providedIn: 'root',
})
export class SkeletonLoaderService {
  private injector = inject(Injector);

  createSkeletonTemplates(viewContainerRef: ViewContainerRef): ComponentRef<SkeletonLoaderTemplatesComponent> {
    // Dynamically create the SkeletonTemplatesComponent using the passed ViewContainerRef
    const componentRef = viewContainerRef.createComponent(SkeletonLoaderTemplatesComponent, {
      injector: this.injector,
    });

    // Optionally append the component's DOM element to the body or another container
    const domElement = componentRef.location.nativeElement;
    document.body.appendChild(domElement);

    return componentRef;
  }
}
